import { useEffect } from 'react'

import { initialBranding } from '@/src/constants/branding'
import { IBranding } from '@/src/types/meetData.type'

export const useBrandingApp = ({
  primary_color = initialBranding?.primary_color,
  text_primary_color = initialBranding?.text_primary_color,
  border_radius = initialBranding?.border_radius,
}: IBranding) => {
  useEffect(() => {
    let isUpdating = false
    let timeoutId: NodeJS.Timeout

    const applyStyles = () => {
      if (isUpdating) return
      isUpdating = true
      const lkButton: NodeListOf<HTMLElement> = document.querySelectorAll('.lk-button')
      const lkButtonsBgEffect: NodeListOf<HTMLElement> =
        document.querySelectorAll('.lk-button-bg-effects')
      const lkParticipantName: NodeListOf<HTMLElement> =
        document.querySelectorAll('.lk-participant-name')
      const lkConnectionQuality: NodeListOf<HTMLElement> =
        document.querySelectorAll('.lk-connection-quality')
      const lkParticipantTile: NodeListOf<HTMLElement> =
        document.querySelectorAll('.lk-participant-tile')

      const lkGridLayout: NodeListOf<HTMLElement> = document.querySelectorAll('.lk-grid-layout')
      const lkChat: HTMLElement | null = document.querySelector('.lk-chat')

      const inputElement: HTMLElement | null = document.querySelector('.lk-chat-form-input')
      const selectedItems: NodeListOf<HTMLElement> = document.querySelectorAll(
        '.lk-media-device-select li',
      )
      const inputVoice: NodeListOf<HTMLElement> = document.querySelectorAll('.lk-grid-layout div')

      inputVoice.forEach((key) => {
        const dataLkActive: string | null = key.getAttribute('data-lk-speaking')
        if (dataLkActive === 'true') {
        }
      })

      selectedItems.forEach((key) => {
        const dataLkActive: string | null = key.getAttribute('data-lk-active')

        if (dataLkActive === 'true') {
          const childElement: HTMLElement | null = key.querySelector('button')
          if (childElement) {
            childElement.style.backgroundColor = primary_color ?? ''
          }
        } else {
          const childElement: HTMLElement | null = key.querySelector('button')
          if (childElement) {
            childElement.style.backgroundColor = ''
          }
        }
      })

      if (inputElement) {
        inputElement.addEventListener('focus', function (e: FocusEvent) {
          ;(e.target as HTMLElement).style.outline = `2px solid ${text_primary_color ?? ''}`
        })
      }

      if (lkChat) {
        lkChat.style.color = text_primary_color ?? ''
      }

      lkButton.forEach((key) => {
        key.style.color = text_primary_color ?? ''
        key.style.fill = text_primary_color ?? ''
        key.style.borderRadius = `${border_radius}px`
      })

      lkButtonsBgEffect.forEach((key) => {
        key.style.color = text_primary_color ?? ''
        key.style.fill = text_primary_color ?? ''
        key.style.borderRadius = `${border_radius}px`
      })

      lkParticipantTile.forEach((key) => {
        const dataSpeaking: string | null = key.getAttribute('data-lk-speaking')
        if (dataSpeaking === 'true') {
          key.style.border = `2px solid ${primary_color}`
          key.style.transitionProperty = 'border'
          key.style.transitionDelay = '0.1s'
          key.style.transitionDuration = '0.4s'
        } else {
          key.style.border = `2px solid transparent`
        }
      })

      lkGridLayout.forEach((key) => {
        key.style.color = primary_color ?? ''
      })

      lkParticipantName.forEach((key) => {
        key.style.color = text_primary_color ?? ''
      })

      lkConnectionQuality.forEach((key) => {
        key.style.color = text_primary_color ?? ''
      })

      isUpdating = false
    }

    const observer = new MutationObserver((mutations) => {
      if (isUpdating) return

      const hasRelevantChanges = mutations.some((mutation) => {
        if (mutation.type === 'childList') {
          return Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node as Element).matches?.(
                '.lk-button, .lk-participant-tile, .lk-chat, .lk-grid-layout, .lk-button-bg-effects, .lk-participant-name, .lk-connection-quality',
              ),
          )
        }
        return false
      })

      if (!hasRelevantChanges) return

      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        requestAnimationFrame(applyStyles)
      }, 50)
    })

    applyStyles()

    observer.observe(document, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
      clearTimeout(timeoutId)
    }
  }, [primary_color, text_primary_color, border_radius])
}
